import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useState } from "react";
import CommonForm from "../../../components/form/form";
import {
  createVendor,
  deleteVendor,
  getVendorList,
  updateVendor,
} from "../../../../services/workspace/inventory.service";
import { useNavigate } from "react-router-dom";

const actions_type = {
  DELETE: "DELETE",
  VIEW: "VIEW",
};

const items = [{ label: "Vendor", path: "" }];

const Vendor = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [isSubCategoryModalOpen, setIsSubCategoryModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const navigate = useNavigate();

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    // selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    fetchData,
    softDelete,
    // New sorting helpers
    sortingUIProps,
  } = useCommonFetch(getVendorList, {
    dataPath: "vendor.data",
    totalPath: "vendor.meta.total",
    errorMessage: "Failed to fetch vendor data!",
    debounceDelay: 500,
    customParams: {
      with: "categories",
    },
    // Dynamic sorting configuration
    sortingOptions: [
      { label: "Name", field: "name" },
      { label: "Date", field: "created_at" },
    ],
    sortingModule: "vendor",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,
    // Add data transformer function
    dataTransformer: (data) => {

      if (Array.isArray(data)) {
        const transformedData = data.map((item, index) => ({
          ...item,
          // Add custom fields or modify existing ones
          id: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
          uuid: {
            data: item.uuid,
            className: "",
            sticky: false,
            variant: "text",
          },
          code: {
            data: item?.code,
            className: "",
            sticky: false,
            variant: "name",
          },
          name: {
            data: item?.name,
            className: "",
            sticky: false,
            variant: "link",
            link:`/inventory/vendor/profile/${item.uuid}`
          },
          categories: {
            data: item?.categories,
            className: "",
            sticky: false,
            variant: "name",
          },
          abrv: {
            data: item.abrv,
            className: "",
            sticky: false,
            variant: "text",
          },
          phone: {
            data: item.phone,
            className: "",
            sticky: false,
            variant: "text",
          },
          phone2: {
            data: item.phone2,
            className: "",
            sticky: false,
            variant: "text",
          },
          country_code:{
            data: item.country_code,
            className: "",
            sticky: false,
            variant: "text",
          },
          country_code2:{
            data: item.country_code2,
            className: "",
            sticky: false,
            variant: "text",
          },
          email:{
            data: item.email,
            className: "",
            sticky: false,
            variant: "text",
          },
          tags:{
            data: item.tags,
            className: "",
            sticky: false,
            variant: "text",
          },
          website:{
            data: item.website,
            className: "",
            sticky: false,
            variant: "text",
          },
          address: {
            data: item.address,
            className: "",
            sticky: false,
            variant: "text",
            customCases: null,
          },
          actions: {
            data: item.id,
            className: "",
            sticky: false,
            variant: "text",
          },
        }));

        const actionButton = {
          delete: (item) => {
            handleDelete(item.uuid.data, deleteVendor, {
              successMessage: "Vendor deleted successfully!",
              errorMessage: "Failed to delete vendor!",
            });
          },
          view: (item) => {
            setIsEditValue(data);
            navigate(`/inventory/vendor/profile/${item.uuid.data}`);
          },
          edit: (item) => {
            // setIsEditValue(data);
            const vendorData = {
              id: item.id.data,
              uuid: item.uuid.data,
              name: item.name.data,
              abrv: item.abrv.data,
              phone: item.phone.data,
              phone2: item.phone2.data,
              address: item.address.data,
              tags: item.tags?.data || "", 
              categories: Array.isArray(item.categories.data)
                ? item.categories.data.map((category) => category.id)
                : item.categories.data?.id
                ? [item.categories.data.id]
                : [],
              email: item.email?.data || "",
              website: item.website?.data || "",
              country_code: item.country_code?.data || "+91",
              country_code2: item.country_code2?.data || "+91",
            };

            setIsEditValue(vendorData);
            navigate(`/inventory/vendor/edit/${item.uuid.data}`, { state: { vendorData } });
          },
        };

        return {
          data: transformedData,
          action: actionButton,
        };
      }
      return { data: [], action: {} };
    },
  });

  const TableHeaderData = [
    {
      label: "Name",
      key: "name",
    },
    {
      label: "Contacts",
      key: "phone",
    },
    {
      label: "Abbreviation",
      key: "abrv",
    },
    {
      label: "Address",
      key: "address",
    },
  ];

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      if (isSubCategoryModalOpen) {
        const payload = {
          ...values,
          parent_id: selectedId?.id?.data,
        };

        await handleCreate(payload, createVendor, {
          successMessage: "Vendor created successfully!",
          errorMessage: "Failed to create vendor!",
        });
      } else if (isEditValue) {
        await handleUpdate(values, isEditValue.uuid, updateVendor, {
          successMessage: "Vendor updated successfully!",
          errorMessage: "Failed to update vendor!",
        });
      } else {
        await handleCreate(values, createVendor, {
          successMessage: "Vendor created successfully!",
          errorMessage: "Failed to create vendor!",
        });
      }
    } finally {
      setSubmitting(false);
      setTimeout(() => {
        resetForm();
      }, 2000);
    }
  };

  return (
    <div className={"flex flex-col gap-2"}>
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        onClickAdd={() => navigate("/inventory/vendor/add", actions_type.ADD)}
        shorting
        sortingModule="vendor"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
      />

      <div className={"flex flex-col gap-2"}>
        <CommonTable
          search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
        />
      </div>
    </div>
  );
};
export default Vendor;
